import React, { Component } from 'react';
import styled from 'styled-components';
import {
  FormCard, FormTextInput, Container, Grid, Alert,
} from 'tabler-react';
import { router } from '../routes';

import { FloatingLink } from './components';
import { AuthFunctions, IsLoggedIn } from './Auth';

const LinkButton = styled.button`
  display: inline;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  letter-spacing: inherit;
  color: #467fcf;
  cursor: pointer;
  &:hover, &:focus {
    color: #295a9f;
    text-decoration: underline;
  }
`;

const errorMessage = e => e.message.replace('GraphQL error: ', '');

// Two-step email sign in: request a one time code for an email, then trade the
// emailed code for an auth token. The API creates the account on the first
// request for a new email, so this covers both login and registration.
class OtpLoginForm extends Component {
  state = {
    email: '', code: '', hasRequestedCode: false, loading: false, error: null,
  };

  componentDidMount() {
    if (this.props.loggedIn) router.navigate({ name: 'Home' });
  }

  onChange = fieldname => ({ target: { value } }) => {
    this.setState({ [fieldname]: value });
  }

  requestCode = async () => {
    const { email } = this.state;
    this.setState({ loading: true, error: null });
    try {
      await this.props.requestOtp({ email: email.trim() });
      this.setState({ hasRequestedCode: true, code: '' });
    } catch (e) {
      this.setState({ error: errorMessage(e) });
    }
    this.setState({ loading: false });
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { email, code, hasRequestedCode } = this.state;
    if (this.state.loading) return;
    if (!email.trim()) {
      this.setState({ error: 'Please enter your email address.' });
      return;
    }
    if (!hasRequestedCode) {
      await this.requestCode();
      return;
    }
    this.setState({ loading: true, error: null });
    try {
      await this.props.loginWithOtp({ email: email.trim(), code: code.trim() });
      router.navigate({ name: 'Home' });
    } catch (err) {
      this.setState({ loading: false, error: errorMessage(err) });
    }
  }

  useDifferentEmail = () => {
    this.setState({ hasRequestedCode: false, code: '', error: null });
  }

  render() {
    const {
      email, code, hasRequestedCode, loading, error,
    } = this.state;
    const {
      title, altLink, children,
    } = this.props;
    let buttonText = hasRequestedCode ? 'Login' : 'Email me a code';
    if (loading) buttonText = hasRequestedCode ? 'Logging in…' : 'Sending code…';
    return (
      <Container>
        <Grid.Row>
          <Grid.Col className="mx-auto mt-6 col-login">
            <FormCard onSubmit={this.onSubmit} title={title} buttonText={buttonText}>
              {altLink && <FloatingLink to={altLink.to}>{altLink.text}</FloatingLink>}
              { error && <Alert type="danger">{error}</Alert> }
              {children}
              {hasRequestedCode ? (
                <React.Fragment>
                  <p>
                    We emailed a 6 digit code to <strong>{email}</strong>. It expires in 10 minutes.
                  </p>
                  <FormTextInput
                    onChange={this.onChange('code')}
                    value={code}
                    label="One Time Code"
                    placeholder="123456"
                    name="code"
                    autoFocus
                  />
                  <p>
                    <LinkButton type="button" onClick={this.requestCode} disabled={loading}>Resend code</LinkButton>
                    {' · '}
                    <LinkButton type="button" onClick={this.useDifferentEmail} disabled={loading}>Use a different email</LinkButton>
                  </p>
                </React.Fragment>
              ) : (
                <FormTextInput
                  onChange={this.onChange('email')}
                  value={email}
                  label="Email"
                  placeholder="Email"
                  name="email"
                  type="email"
                />
              )}
            </FormCard>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default props => (
  <IsLoggedIn>
    {isLoggedIn => (
      <AuthFunctions>
        {({ requestOtp, loginWithOtp }) => (
          <OtpLoginForm
            {...props}
            loggedIn={isLoggedIn}
            requestOtp={requestOtp}
            loginWithOtp={loginWithOtp}
          />
        )}
      </AuthFunctions>
    )}
  </IsLoggedIn>
);



// WEBPACK FOOTER //
// ./src/auth/OtpForm.js